<template>
  <v-toolbar id="supheader" dense flat>
    <v-toolbar-title>
      <v-breadcrumbs :items="breadcrumbs" divider=">"></v-breadcrumbs>
    </v-toolbar-title>
  </v-toolbar>
</template>

<script>
export default {
  props: {
    routeId: String,
    name: String,
  },
  computed: {
    breadcrumbs() {
      return [
        {
          text: "Database",
          to: { name: "database" },
        },
        {
          text: `Routes`,
          to: { name: "database_view", params: { view: "routes", sub: "ALL" } },
        },
        {
          text: this.name || "New Route",
        },
      ];
    },
  },
};
</script>
